import React, { useState } from 'react';
import { locations, galleryImages } from '../mockData';
import { Card } from '../components/ui/card';

const Gallery = () => {
  const [selectedLocation, setSelectedLocation] = useState('all');

  const filteredImages = selectedLocation === 'all'
    ? galleryImages
    : galleryImages.filter(img => img.locationId === parseInt(selectedLocation));

  return (
    <div className="min-h-screen bg-black">
      {/* Header */}
      <div className="bg-gradient-to-r from-yellow-600 to-yellow-400 py-16">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 text-center">
          <h1 className="text-5xl font-bold text-black mb-4">Gallery</h1>
          <p className="text-xl text-gray-900">Experience our world-class facilities</p>
        </div>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        {/* Filters */}
        <div className="mb-8">
          <div className="flex flex-wrap gap-3 justify-center">
            <button
              onClick={() => setSelectedLocation('all')}
              className={`px-6 py-2 rounded-full font-semibold transition-all ${
                selectedLocation === 'all'
                  ? 'bg-yellow-400 text-black'
                  : 'bg-gray-900 text-white border border-yellow-500/20 hover:border-yellow-400'
              }`}
            >
              All Locations
            </button>
            {locations.map((location) => (
              <button
                key={location.id}
                onClick={() => setSelectedLocation(location.id.toString())}
                className={`px-6 py-2 rounded-full font-semibold transition-all ${
                  selectedLocation === location.id.toString()
                    ? 'bg-yellow-400 text-black'
                    : 'bg-gray-900 text-white border border-yellow-500/20 hover:border-yellow-400'
                }`}
              >
                {location.name}
              </button>
            ))}
          </div>
        </div>

        {/* Gallery Grid */}
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {filteredImages.map((image) => (
            <div key={image.id} className="group cursor-pointer">
              <div className="relative h-64 rounded-xl overflow-hidden">
                <img
                  src={image.url}
                  alt={image.title}
                  className="w-full h-full object-cover group-hover:scale-110 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/80 to-transparent opacity-0 group-hover:opacity-100 transition-opacity">
                  <div className="absolute bottom-4 left-4 right-4">
                    <p className="text-white font-semibold">{image.title}</p>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default Gallery;